import { useEffect, useState } from "react";


export interface ComponentSizes {
    width: number;
    height: number;
}

/**
 * Хук для отслеживания размеров компонента.
 * @returns {object} Объект с шириной и высотой (px)
 * */
export default function useComponentSize(ref: any): ComponentSizes {
    const [width, setWidth] = useState<number>(window.innerWidth);
    const [height, setHeight] = useState<number>(window.innerHeight);

    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            const { width, height } = entries[0].contentRect;
            setHeight(height);
            setWidth(width);
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref]);

    const handleResize = () => {
        setWidth(ref.current.offsetWidth);
        setHeight(ref.current.offsetHeight);
    }

    return {
        width: width,
        height: height,
    }
}
